var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,35.8c-2.2,0.4-4.3,0.3-6.4-0.1s-3.9-1.2-5.7-2.4c-1.7-1.1-3.2-2.5-4.4-4.2c-1.2-1.7-2.2-3.6-2.8-5.7H6.1 v-4.1h3.8v-2.4H6.1v-4.1h4.6c0.6-2.1,1.5-4.1,2.8-5.8c1.3-1.7,2.7-3.1,4.5-4.2c1.7-1.1,3.6-1.9,5.6-2.3c2-0.4,4.2-0.5,6.4-0.1v6.2 c-1.4-0.4-2.7-0.5-4-0.3c-1.3,0.1-2.5,0.5-3.6,1.1c-1.1,0.6-2.1,1.3-3,2.3c-0.9,0.9-1.6,2-2.1,3.2h6.7v4.1h-8l0,2.4h7.9v4.1h-6.7 c0.6,1.2,1.3,2.3,2.2,3.2c0.9,0.9,1.9,1.7,3,2.2c1.1,0.5,2.3,0.9,3.6,1c1.3,0.1,2.6,0,3.9-0.4V35.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEur);
export default __webpack_public_path__ + "static/media/icon-eur.e9b68ff81ed20ce517bbfe72f5c2bb23.svg";
export { ForwardRef as ReactComponent };